import {
	CustomDestination, SettingsReducerState, DefaultMeetingImage,
} from '../reducers/settings';
import { FetchFeatureFlags, FetchFeatureFlagOverrides } from '../../connection/utils';
import { Action } from '../types/types';

interface Setting {
	type: string,
	payload: any
}

interface AsyncAction {
	type: string;
	promise: Promise<any>
}

export const GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS';
export function getFeatureFlags(): AsyncAction {
	return {
		type: GET_FEATURE_FLAGS,
		promise: FetchFeatureFlags(),
	};
}

export const GET_FEATURE_FLAG_OVERRIDES = 'GET_FEATURE_FLAG_OVERRIDES';
export function getFeatureFlagOverrides(meeting: number): AsyncAction {
	return {
		type: GET_FEATURE_FLAG_OVERRIDES,
		promise: FetchFeatureFlagOverrides(meeting),
	};
}

export const SET_HAS_SYNCED = 'SET_HAS_SYNCED';
export function setHasSynced(hasSynced: boolean): Action {
	return {
		type: SET_HAS_SYNCED,
		payload: hasSynced,
	};
}

export const SET_MODERATED_QUESTIONS = 'SET_MODERATED_QUESTIONS';
export function setModeratedQuestions(on: boolean): Setting {
	return {
		type: SET_MODERATED_QUESTIONS,
		payload: on,
	};
}

export const REPLACE_STATE = 'REPLACE_STATE';
export function replaceState(state: SettingsReducerState) {
	return {
		type: REPLACE_STATE,
		payload: state,
	};
}

export const SET_TEMPLATE_ACCORDION = 'SET_TEMPLATE_ACCORDION';
export function setTemplateAccordion(templateAccordionOpen: boolean) {
	return {
		type: SET_TEMPLATE_ACCORDION,
		payload: templateAccordionOpen,
	};
}

export const SET_SPACING_ACCORDION = 'SET_SPACING_ACCORDION';
export function setSpacingAccordion(spacingAccordionOpen: boolean) {
	return {
		type: SET_SPACING_ACCORDION,
		payload: spacingAccordionOpen,
	};
}

export const SET_WALLPAPER_ACCORDION = 'SET_WALLPAPER_ACCORDION';
export function setWallpaperAccordion(wallpaperAccordionOpen: boolean) {
	return {
		type: SET_WALLPAPER_ACCORDION,
		payload: wallpaperAccordionOpen,
	};
}

export const SET_BACKGROUND_ACCORDION = 'SET_BACKGROUND_ACCORDION';
export function setBackgroundAccordion(backgroundAccordionOpen: boolean) {
	return {
		type: SET_BACKGROUND_ACCORDION,
		payload: backgroundAccordionOpen,
	};
}

export const SET_GREENROOM_SETTINGS_ACCORDION = 'SET_GREENROOM_SETTINGS_ACCORDION';
export function setGreenroomSettingsAccordion(greenroomSettingsAccordionOpen: boolean) {
	return {
		type: SET_GREENROOM_SETTINGS_ACCORDION,
		payload: greenroomSettingsAccordionOpen,
	};
}

export const SET_ASK_TO_JOIN = 'SET_ASK_TO_JOIN';
export function setAskToJoin(askToJoin: boolean) {
	return {
		type: SET_ASK_TO_JOIN,
		payload: askToJoin,
	};
}

export const SET_SELECTED_BROADCAST_RESOLUTION = 'SET_SELECTED_BROADCAST_RESOLUTION';
export function setSelectedBroadcastResolution(res: string) {
	return {
		type: SET_SELECTED_BROADCAST_RESOLUTION,
		payload: res,
	};
}

export const SET_SETTINGS_TAB = 'SET_SETTINGS_TAB';
export function setSettingsTab(tab: number) {
	return {
		type: SET_SETTINGS_TAB,
		payload: tab,
	};
}

export const SET_ENTRY_WITHOUT_PRODUCER = 'SET_ENTRY_WITHOUT_PRODUCER';
export function setEntryWithoutProducer(entryWithoutProducer: boolean) {
	return {
		type: SET_ENTRY_WITHOUT_PRODUCER,
		payload: entryWithoutProducer,
	};
}

export const SET_BACKSTAGE_COMMS_ACTIVE = 'SET_BACKSTAGE_COMMS_ACTIVE';
export function setBackstageCommsActive(backstageCommsActive: boolean) {
	return {
		type: SET_BACKSTAGE_COMMS_ACTIVE,
		payload: backstageCommsActive,
	};
}

export const SET_OVERLAY_VISIBLE = 'SET_OVERLAY_VISIBLE';
export function setOverlayVisible(visible: boolean) {
	return {
		type: SET_OVERLAY_VISIBLE,
		payload: visible,
	};
}

export const SET_USE_DEFAULT_ENDPOINT = 'SET_USE_DEFAULT_ENDPOINT';
export function setUseDefaultEndpoint(useDefaultEndpoint: boolean) {
	return {
		type: SET_USE_DEFAULT_ENDPOINT,
		payload: useDefaultEndpoint,
	};
}

export const SET_DEFAULT_RESOLUTION = 'SET_DEFAULT_RESOLUTION';
export function setDefaultResolution(defaultResolution: string) {
	return {
		type: SET_DEFAULT_RESOLUTION,
		payload: defaultResolution,
	};
}

export const ADD_CUSTOM_DESTINATION = 'ADD_CUSTOM_DESTINATION';
export function addCustomDestination(customDestination: CustomDestination) {
	return {
		type: ADD_CUSTOM_DESTINATION,
		payload: customDestination,
	};
}

export const UPDATE_CUSTOM_DESTINATION = 'UPDATE_CUSTOM_DESTINATION';
export function updateCustomDestination(customDestination: CustomDestination) {
	return {
		type: UPDATE_CUSTOM_DESTINATION,
		payload: customDestination,
	};
}

export const REMOVE_CUSTOM_DESTINATION = 'REMOVE_CUSTOM_DESTINATION';
export function removeCustomDestination(id: string) {
	return {
		type: REMOVE_CUSTOM_DESTINATION,
		payload: id,
	};
}

export const SET_SELECTED_CUSTOM_DESTINATION = 'SET_SELECTED_CUSTOM_DESTINATION';
export function setSelectedCustomDestination(id: string) {
	return {
		type: SET_SELECTED_CUSTOM_DESTINATION,
		payload: id,
	};
}

export const SET_USE_EMAIL_INVITES = 'SET_USE_EMAIL_INVITES';
export function setUseEmailInvites(useEmailInvites: boolean) {
	return {
		type: SET_USE_EMAIL_INVITES,
		payload: useEmailInvites,
	};
}

export const SET_CLEAR_SHOT = 'SET_CLEAR_SHOT';
export function setClearShot(clearShot: boolean) {
	return {
		type: SET_CLEAR_SHOT,
		payload: clearShot,
	};
}

export const SET_USE_SHOWBOARD = 'SET_USE_SHOWBOARD';
export function setUseShowboard(useShowboard: boolean) {
	return {
		type: SET_USE_SHOWBOARD,
		payload: useShowboard,
	};
}

export const SET_DEFAULT_MEETING_IMAGE = 'SET_DEFAULT_MEETING_IMAGE';
export function setDefaultMeetingImage(imageData: DefaultMeetingImage) {
	return {
		type: SET_DEFAULT_MEETING_IMAGE,
		payload: imageData,
	};
}

export const SET_FEED_SCALING = 'SET_FEED_SCALING';
export function setFeedScaling(feedScaling: boolean) {
	return {
		type: SET_FEED_SCALING,
		payload: feedScaling,
	};
}

export const SYNC_SETTINGS_REDUCER_STATE = 'SYNC_SETTINGS_REDUCER_STATE';
export function syncSettingsReducerState(state: any) {
	return {
		type: SYNC_SETTINGS_REDUCER_STATE,
		payload: state,
	};
}

export const UPDATE_FEATURE_FLAG = 'UPDATE_FEATURE_FLAG';
export function updateFeatureFlag(state: [string, boolean]) {
	return {
		type: UPDATE_FEATURE_FLAG,
		payload: state,
	};
}

export const SET_PRESENTER_AUDIENCE_TAB = 'SET_PRESENTER_AUDIENCE_TAB';
export function setPresenterAudienceTab(presenterAudienceTab: boolean) {
	return {
		type: SET_PRESENTER_AUDIENCE_TAB,
		payload: presenterAudienceTab,
	};
}
